/**
 * Created by Jonas Wålekvist on 2018-08-29.
 */
import {TimelineLite} from "gsap";
import {DirtyWildGameModuleConfig} from "../DirtyWildGameModuleConfig";
import {DirtyWildGameMode} from "../features/DirtyWildsRespinZeroBetController";

export class DirtyWildEffectManager {


    constructor() {}

    public getTeaseIntense(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            DirtyWildGameModuleConfig.environment.getTransition(DirtyWildGameMode.STICKY_RESPIN, duration)]);
        return tl;
    }

    public getBackgroundZoomAnimation(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            DirtyWildGameModuleConfig.environment.getDollyZoomIn(duration, 0)
        ]);
        return tl;
    }

    public getChangeBackgroundAnimation(mode:DirtyWildGameMode, duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        if(mode == DirtyWildGameMode.STICKY_RESPIN) {
            tl.add([
                DirtyWildGameModuleConfig.environment.getTransition(mode, duration),
                DirtyWildGameModuleConfig.environment.getDollyZoomIn(duration, 0)
            ]);

        } else {
            tl.add([
                DirtyWildGameModuleConfig.environment.getTransition(mode, duration),
                DirtyWildGameModuleConfig.environment.getDollyZoomOut(duration)
            ]);
        }

        return tl;
    }
}